import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export default function isSelectionInLastTableRow(editor) {
  var tableId = editor.getCurrentTableId();
  var cells = editor.getTableCells(tableId);

  if (cells.isEmpty()) {
    return false;
  }

  var _editor$getCellCoords = editor.getCellCoords(cells.last()),
      _editor$getCellCoords2 = _slicedToArray(_editor$getCellCoords, 1),
      lastRowIndex = _editor$getCellCoords2[0];

  var _editor$getCellCoords3 = editor.getCellCoords(editor.value.startBlock),
      _editor$getCellCoords4 = _slicedToArray(_editor$getCellCoords3, 1),
      endBlockRowIndex = _editor$getCellCoords4[0];

  var _editor$getCellCoords5 = editor.getCellCoords(editor.value.endBlock),
      _editor$getCellCoords6 = _slicedToArray(_editor$getCellCoords5, 1),
      startBlockRowIndex = _editor$getCellCoords6[0];

  return lastRowIndex === endBlockRowIndex || lastRowIndex === startBlockRowIndex;
}